import style from './style.css';

const UserEligibilityContainer = ({ bicAction }) => {
  return (
    <div className={style.userEligibilityContainer}>
      <div className={style.userEligibilityTextContainer}>
        <img
          className={style.logoImage}
          src='https://iccdn.in/bic/icons/guest-logo.svg'
          alt='cart-logo'
        />
        <div className={style.textContainer}>
          <span className={style.cardlessEmiText}>Activate Cardless EMI</span>{' '}
          from Trusted Banks/NBFC
        </div>
      </div>
    </div>
  );
};

export default UserEligibilityContainer;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/checkEligibilty/userEligibiltycontainer/index.js